import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ExternalLink, LinkedLogo, NamedLink } from '../../components';
import Icons from '../../components/Icons/Icons';
import paymentMode from '../../assets//take-a-chef-payment-methods.svg';
import { UserTypePreference } from '../../util/enums';
import css from './FooterContainer.module.css';

function FooterContainer(props) {
  const intl = useIntl();
  const supportEmail = intl.formatMessage({ id: 'Footer.supportEmail' });

  const socialLinks = [
    {
      href: 'https://www.instagram.com/ifihadachef/',
      icon: 'instagram',
      labelId: 'Footer.social.instagram',
    },
    {
      href: 'https://www.linkedin.com/in/glennmorel',
      icon: 'linkedin',
      labelId: 'Footer.social.linkedin',
    },
  ];

  const sitemapLinks = [
    { name: 'SearchPage', labelId: 'Footer.link.ourChefs' },
    {
      name: 'SignupForUserTypePage',
      params: { userType: UserTypePreference.PRIVATE_CHEFS },
      labelId: 'Footer.link.chefRegister',
    },
    { name: 'LandingPage', to: { hash: '#faq' }, labelId: 'Footer.link.faq' },
    { name: 'CMSPage', params: { pageId: 'about' }, labelId: 'Footer.link.aboutUs' },
    { name: 'LoginPage', labelId: 'Footer.link.signIn' },
    { name: 'TermsOfServicePage', labelId: 'Footer.link.termsOfService' },
    { name: 'PrivacyPolicyPage', labelId: 'Footer.link.privacyPolicy' },
    { href: `mailto:${supportEmail}`, labelId: 'Footer.link.contactUs' },
  ];

  return (
    <div className={css.footer}>
      <div className={css.footerTop}>
        <div className={css.fixedWidthContainer}>
          <div className={css.leftBlock}>
            <div className={css.linksBlock}>
              <p>{intl.formatMessage({ id: 'Footer.followUs' })}</p>
              <div className={css.socialLinks}>
                {socialLinks.map(link => (
                  <ExternalLink
                    key={link.icon}
                    href={link.href}
                    className={css.link}
                    aria-label={intl.formatMessage({ id: link.labelId })}
                  >
                    <Icons name={link.icon} />
                  </ExternalLink>
                ))}
              </div>
            </div>
            <div className={css.linksBlock}>
              <p>{intl.formatMessage({ id: 'Footer.letsTalk' })}</p>
              <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </div>
            <div className={css.linksBlock}>
              <p>{intl.formatMessage({ id: 'Footer.securePayment' })}</p>
              <div className={css.paymentOptionImg}>
                <img src={paymentMode} alt={intl.formatMessage({ id: 'Footer.paymentAlt' })} />
              </div>
            </div>
          </div>
          <div className={css.rightBlock}>
            <FooterLinksBlock
              intl={intl}
              isSitemapLinks={true}
              titleId="Footer.sitemap"
              links={sitemapLinks}
            />
          </div>
        </div>
      </div>

      <div className={css.footerBottom}>
        <div className={css.fixedWidthContainer}>
          <div className={css.footerBottomLeft}>
            <LinkedLogo
              className={css.logo}
              title={intl.formatMessage({ id: 'Topbar.logoIcon' })}
            />
            <p>
              {intl.formatMessage({ id: 'Footer.copyright' }, { year: new Date().getFullYear() })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function FooterLinksBlock({ intl, titleId, links, isSitemapLinks }) {
  return (
    <div className={css.linksBlock}>
      <h2>{intl.formatMessage({ id: titleId })}</h2>
      {isSitemapLinks ? (
        <div className={css.sitemapLinksBlock}>
          {links.map(link =>
            link.href ? (
              <a key={link.labelId} href={link.href} className={css.link}>
                <span>{intl.formatMessage({ id: link.labelId })}</span>
              </a>
            ) : (
              <NamedLink
                key={link.labelId}
                className={css.link}
                name={link.name}
                params={link.params}
                to={link.to}
              >
                <span>{intl.formatMessage({ id: link.labelId })}</span>
              </NamedLink>
            )
          )}
        </div>
      ) : null}
    </div>
  );
}

export default FooterContainer;
